<p-dialog
	header="Select File"
	[(visible)]="visible"
	[modal]="true"
	[dismissableMask]="true"
	[style]="{ width: '640px', maxHeight: '80vh' }"
	appendTo="body"
	(onHide)="onHide()"
>
	<!-- Search -->
	<div class="mb-3">
		<input
			pInputText
			class="w-full"
			placeholder="Search files..."
			[ngModel]="searchQuery()"
			(ngModelChange)="searchQuery.set($event)"
		/>
	</div>

	<!-- File grid -->
	<div class="picker-grid">
		@for (file of filteredFiles(); track file.baseUrl) {
			<button
				class="picker-item"
				[class.picker-item--selected]="isSelected(file)"
				[class.picker-item--variant-group]="file.variants"
				(click)="selectFile(file)"
				[title]="file.name"
			>
				@if (isSelected(file)) {
					<span class="picker-item-check" aria-label="Currently selected">
						<i class="pi pi-check"></i>
					</span>
				}
				@if (file.variants) {
					<!-- Variant group: folder icon + count badge, clicking selects the template URL -->
					<div class="picker-icon">
						<i class="pi pi-folder text-lg"></i>
						<span class="picker-variant-badge">{{ file.variants.length }}</span>
					</div>
				} @else if (isImageCategory(file)) {
					<img [src]="file.previewUrl" [alt]="file.name" class="picker-preview" loading="lazy" />
				} @else {
					<div class="picker-icon">
						@if (isVideoCategory(file)) {
							<i class="pi pi-video text-lg"></i>
						} @else if (file.category === 'fonts') {
							<i class="pi pi-palette text-lg"></i>
						} @else if (file.category === 'audios') {
							<i class="pi pi-volume-up text-lg"></i>
						} @else {
							<i class="pi pi-file text-lg"></i>
						}
					</div>
				}
				<span class="picker-name">{{ stripExt(file.name) }}</span>
			</button>
		}
		@if (filteredFiles().length === 0) {
			<div class="col-span-full text-center py-8 text-wb-muted text-sm">No files found</div>
		}
	</div>

	<!-- Footer -->
	<div class="mt-3 flex items-center justify-between">
		<span class="text-[0.7rem] text-wb-muted">{{ filteredFiles().length }} files</span>
		@if (multi() && selectedUrls().size > 0) {
			<button class="add-item-btn" type="button" (click)="confirmMulti()">
				<i class="pi pi-check text-[9px]"></i> Add {{ selectedUrls().size }} selected
			</button>
		}
	</div>
</p-dialog>
